import VueRouter, { Route } from 'vue-router';
import { IModal, modalService } from '@gig/magic-common';
import { ACCOUNT_PEP_BLOCK_QUERY } from '@gig/magic-messages';
import { RouteName } from '../../../routes/routes.constants';

/**
 * Guard to check if pep block is in place
 * @param router
 */
export function initPepGuard(router: VueRouter) {
    let modalRef: IModal | null = null;
    router.beforeEach(async (to, from, next) => {
        if (!(await isPepBlocked())) {
            return next();
        }

        if (isLoggingOut(to)) {
            if (modalRef) {
                modalService.close(modalRef);
                modalRef = null;
            }
            return next();
        }

        if (isPepModalOpen()) {
            if (to.name !== RouteName.HOME && to.name !== RouteName.LIVE_CHAT) {
                return next(
                    new Error(
                        'Navigation canceled due to user block (pep block)',
                    ),
                );
            } else {
                return next();
            }
        }

        const modal = document.createElement('magic-pep-block-modal');
        const header = 'agco-pep-block-modal.title';
        const modalOptions = {
            dismissible: false,
            keepAfterClear: true,
            dismissibleBackdrop: false,
            displayOnTop: true,
            onClose: () => {
                modalRef = null;
                router.push({
                    name: RouteName.LOGOUT,
                });
            },
        };
        modalRef = modalService.open(header, modal, modalOptions);

        next({
            name: RouteName.HOME,
        });
    });
}

function isPepBlocked(): Promise<boolean> {
    return window.queryBus.query(ACCOUNT_PEP_BLOCK_QUERY);
}

function isPepModalOpen() {
    return document.getElementsByTagName('magic-pep-block-modal').length != 0;
}

function isLoggingOut(to: Route) {
    return to.name === RouteName.LOGOUT;
}
